import { z } from 'zod';

/**
 * How a challenge's code comes to exist — **stored on the challenge row**, so
 * a confirm is judged by the strategy the code was issued under, never by the
 * provider that happens to be active at the time (P30 decision 5).
 *
 * `send` — the platform mints the code, stores its HMAC and hands the words to
 *   a transport (email; an SMS aggregator in P30b1).
 * `managed` — a vendor mints, delivers and checks the code (Twilio Verify);
 *   the row keeps the vendor's reference and no hash, while attempts, cooldown
 *   and the hourly window are still the platform's.
 *
 * Backed by the Postgres enum `access.verification_strategy` — append only.
 */
export const VERIFICATION_STRATEGIES = ['send', 'managed'] as const;

export const VerificationStrategySchema = z.enum(VERIFICATION_STRATEGIES);

export type VerificationStrategy = z.infer<typeof VerificationStrategySchema>;
